import { useCallback, useMemo } from "react";

import { ModalTable } from "components/BaseTableV3/ModalTable";
import { getNextQueryParams } from "components/helpers";
import CampaignScheduleService from "services/CampaignScheduleService";
import { useScheduleViewContactsTable } from "hooks/useScheduleViewContactsTable";
import ScheduleViewContactsTableExtraButtons from "routes/campaign/components/email_schedule_contacts_table/ScheduleViewContactsTableExtraButtons";

export const SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS = {
  tableName: "email_schedule_contacts",
  className: "EmailScheduleContacts",
  exportTableName: "ScheduleViewContactsTable",
  header: "Email Schedule Contacts",
  headerIcon: "mail outline",
  tagModel: "contact",
};

const ScheduleViewContactsTableV3 = ({ campaignId, data }) => {
  const { columns, queryKey } = useScheduleViewContactsTable({
    campaignId,
    data,
  });

  const fetchScheduleViewContacts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CampaignScheduleService.getEmailableContactsForSchedule(
            campaignId,
            data,
            nextQueryParams
          );

        return response;
      } catch (error) {
        console.error("Error fetching schedule view contacts:", error);
        throw error;
      }
    },
    [columns, campaignId, data]
  );

  const extraButtons = useCallback(extra => {
    if (!extra) return null;

    return (
      <ScheduleViewContactsTableExtraButtons
        emailCount={extra.email_count}
        entityCount={extra.entity_count}
      />
    );
  }, []);

  const downloadParams = useMemo(
    () => ({
      campaign_id: campaignId,
      data: JSON.stringify(data),
    }),
    [campaignId, data]
  );

  return (
    <ModalTable
      columns={columns}
      headerIcon={SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS.headerIcon}
      header={SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS.header}
      queryKey={queryKey}
      exportTableName={SCHEDULE_VIEW_CONTACTS_TABLE_CONSTANTS.exportTableName}
      extraButtons={extraButtons}
      fetchData={fetchScheduleViewContacts}
      downloadParams={downloadParams}
      enableSearch
    />
  );
};

export default ScheduleViewContactsTableV3;
